import { TasksTabsComponent } from './tasks-tabs.component';

export default angular
  .module('sfMobile.components.tasks-tabs', [
    'sfMobile.components.tasks-list',
    'sfMobile.constants.task-statuses',
  ])
  .component('sfTasksTabs', TasksTabsComponent).name;
